export enum Stage {
    LOCAL = 'local',
    DEV = 'dev',
    QA = 'qa',
    PROD = 'prod',
    TEST = 'test'
}
